import React from "react";
import "./DashboardSkeleton.css";

const SkeletonText = ({ width, height, style = {} }) => (
  <div className="skeleton-text" style={{ width, height, ...style }}></div>
);

const SkeletonCircle = ({ size, style = {} }) => (
  <div
    className="skeleton-circle"
    style={{ width: size, height: size, ...style }}
  ></div>
);

const SkeletonChart = ({ height = "300px" }) => (
  <div className="skeleton-body" style={{ height }}>
    <div className="skeleton-chart"></div>
  </div>
);

// Individual skeleton components for each card
export const LastUpdateSkeleton = () => (
  <div className="d-flex flex-row">
    <div className="m-2">
      <SkeletonText width="250px" height="20px" />
    </div>
    <div className="m-2">
      <SkeletonText width="40px" height="40px" />
    </div>
  </div>
);

export const DateRangeSkeleton = () => (
  <div className="d-flex flex-row gap-2">
    <div className="m-2">
      <SkeletonText width="100px" height="20px" />
    </div>
    <div>
      <SkeletonText width="150px" height="38px" />
    </div>
    <div>
      <SkeletonText width="120px" height="38px" />
    </div>
    <div>
      <SkeletonText width="120px" height="38px" />
    </div>
  </div>
);

export const DeviceReceivedSkeleton = () => (
  <>
    <h6 className="mt-3">Device Received</h6>
    <div style={{ width: "80%", padding: "30px" }}>
      <SkeletonChart height="400px" />
    </div>
  </>
);

export const ServiceTypesSkeleton = () => (
  <>
    <h6 className="mt-3">Service Types</h6>
    <div className="skeleton-body">
      <SkeletonCircle size="300px" style={{ margin: "30px auto" }} />
    </div>
  </>
);

export const TicketStatusCustomSkeleton = () => (
  <>
    <h6 className="mt-3">Ticket Status</h6>
    <div className="skeleton-body">
      <SkeletonCircle size="300px" style={{ margin: "30px auto" }} />
    </div>
  </>
);

export const WarrantyStatusSkeleton = () => (
  <>
    <h6 className="mt-3">Warranty Status</h6>
    <div className="skeleton-body">
      <SkeletonCircle size="300px" style={{ margin: "30px auto" }} />
    </div>
  </>
);

// Main custom dashboard skeleton component
const CustomDashboardSkeleton = ({
  showLastUpdate = true,
  showDateRange = true,
  showDeviceReceived = true,
  showServiceTypes = true,
  showTicketStatus = true,
  showWarrantyStatus = true,
}) => {
  return (
    <div className="dashboard-skeleton">
      {/* Last Update and Date Range Section */}
      {(showLastUpdate || showDateRange) && (
        <div className="d-flex flex-row justify-content-between card p-2">
          {showLastUpdate && <LastUpdateSkeleton />}
          {showDateRange && <DateRangeSkeleton />}
        </div>
      )}

      {/* Device Received Chart */}
      {showDeviceReceived && (
        <div className="row mt-1">
          <div className="col-md-12">
            <div className="skeleton-card" style={{ textAlign: "center" }}>
              <DeviceReceivedSkeleton />
            </div>
          </div>
        </div>
      )}

      {/* Service Types and Ticket Status */}
      <div className="row mt-3">
        <div className="col-md-6">
          {showServiceTypes && (
            <div className="skeleton-card" style={{ textAlign: "center" }}>
              <ServiceTypesSkeleton />
            </div>
          )}
        </div>

        <div className="col-md-6">
          {showTicketStatus && (
            <div className="skeleton-card" style={{ textAlign: "center" }}>
              <TicketStatusCustomSkeleton />
            </div>
          )}
        </div>
      </div>

      {/* Warranty Status */}
      <div className="row mt-3">
        <div className="col-md-6">
          {showWarrantyStatus && (
            <div className="skeleton-card" style={{ textAlign: "center" }}>
              <WarrantyStatusSkeleton />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomDashboardSkeleton;